import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { HiOutlineLockClosed } from 'react-icons/hi';

/**
 * TruncatedText — displays text that may have been truncated by the backend (ending with "...").
 * When truncated, shows an inline CTA prompting the user to subscribe or log in.
 * Safe for null/empty/short text — renders nothing if no meaningful content.
 */
const TruncatedText = ({ text, className = '' }) => {
  const { isAuthenticated, hasActiveSubscription } = useAuth();
  const navigate = useNavigate();

  if (!text || text.length < 20) return null;

  const isTruncated = text.endsWith('...');

  // Full subscribers see the full text without any CTA
  if (hasActiveSubscription) {
    return (
      <p className={`text-base text-gray-700 whitespace-pre-line ${className}`}>
        {text}
      </p>
    );
  }

  return (
    <div>
      <p className={`text-base text-gray-700 whitespace-pre-line ${className}`}>
        {text}
      </p>
      {isTruncated && (
        <div className="mt-3 flex items-center gap-2 px-3 py-2 bg-gradient-to-r from-indigo-50 to-amber-50 rounded-lg border border-indigo-100">
          <HiOutlineLockClosed className="w-4 h-4 text-indigo-500 flex-shrink-0" />
          <span className="text-sm text-gray-600">
            {isAuthenticated ? (
              <>
                Pentru informatii complete,{' '}
                <button
                  onClick={() => navigate('/abonamente')}
                  className="text-indigo-600 font-semibold hover:text-indigo-800 underline underline-offset-2"
                >
                  activeaza un abonament
                </button>
              </>
            ) : (
              <>
                Pentru informatii complete,{' '}
                <button
                  onClick={() => navigate(`/login?redirect=${encodeURIComponent(window.location.pathname)}`)}
                  className="text-indigo-600 font-semibold hover:text-indigo-800 underline underline-offset-2"
                >
                  autentifica-te
                </button>
                {' '}sau{' '}
                <button
                  onClick={() => navigate('/register')}
                  className="text-indigo-600 font-semibold hover:text-indigo-800 underline underline-offset-2"
                >
                  creeaza un cont
                </button>
              </>
            )}
          </span>
        </div>
      )}
    </div>
  );
};

export default TruncatedText;
